// extracted by mini-css-extract-plugin
export default {"shop-button":"shop-replacement-button__shop-button___1JGRk"};